<template>
    <danger-button
        modal-name="delete-email-account-or-alias"
        :action="actionUrl"
        :redirect-to="route('front.my-pages.broadband.index')"
        danger-button-size="sm"
        :title="lang('Ta bort e-postadress','Delete e-mail address')"
        :primary-button-text="lang('Ta bort e-postadress','Delete e-mail address')"
        :close-button-text="lang('Avbryt','Cancel')"
    >
        {{ lang('Ta bort','Delete') }} {{ emailAccountOrAlias.is_alias ? lang('vidarebefodring','forwarding') : lang('e-postkonto','e-mail account') }}
        <template v-slot:modal-content>
            <p>
                {{ lang('Vill du verkligen ta bort e-postadressen','Are you sure you want to delete the e-mail address') }}?
            </p>
        </template>
    </danger-button>
</template>

<script>
    export default {
        props: {
            emailAccountOrAlias: {
                type: Object,
                required: true,
            },
        },

        computed: {
            actionUrl() {
                if (this.emailAccountOrAlias.is_alias) {
                    return route('front.my-pages.api.email-aliases.destroy', this.emailAccountOrAlias);
                }

                return route('front.my-pages.api.email-accounts.destroy', this.emailAccountOrAlias);
            },
        },
    };
</script>